/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Zoom_In_TitleInputs */

const en_timeline_zoom_in_title = /** @type {(inputs: Timeline_Zoom_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom In`)
};

const fr_timeline_zoom_in_title = /** @type {(inputs: Timeline_Zoom_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoomer`)
};

const de_timeline_zoom_in_title = /** @type {(inputs: Timeline_Zoom_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergrößern`)
};

const it_timeline_zoom_in_title = /** @type {(inputs: Timeline_Zoom_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrandisci`)
};

const ru_timeline_zoom_in_title = /** @type {(inputs: Timeline_Zoom_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличить масштаб`)
};

const es_timeline_zoom_in_title = /** @type {(inputs: Timeline_Zoom_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dar un golpe de zoom`)
};

const zh_cn2_timeline_zoom_in_title = /** @type {(inputs: Timeline_Zoom_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放大`)
};

const ja_timeline_zoom_in_title = /** @type {(inputs: Timeline_Zoom_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ズームイン`)
};

const hi_timeline_zoom_in_title = /** @type {(inputs: Timeline_Zoom_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ज़ूम इन`)
};

const pt_pt2_timeline_zoom_in_title = /** @type {(inputs: Timeline_Zoom_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ampliar`)
};

/**
* | output |
* | --- |
* | "Zoom In" |
*
* @param {Timeline_Zoom_In_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_zoom_in_title = /** @type {((inputs?: Timeline_Zoom_In_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Zoom_In_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_zoom_in_title(inputs)
	if (locale === "de") return de_timeline_zoom_in_title(inputs)
	if (locale === "it") return it_timeline_zoom_in_title(inputs)
	if (locale === "ru") return ru_timeline_zoom_in_title(inputs)
	if (locale === "es") return es_timeline_zoom_in_title(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_zoom_in_title(inputs)
	if (locale === "ja") return ja_timeline_zoom_in_title(inputs)
	if (locale === "hi") return hi_timeline_zoom_in_title(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_zoom_in_title(inputs)
	return en_timeline_zoom_in_title(inputs)
});